// extracted by mini-css-extract-plugin
module.exports = {"guidePage":"GuidePage_guidePage__y7NS3","content":"GuidePage_content__v1AP3"};